import React from 'react';
import { parseISO } from 'date-fns';
import Card from './Card';
import './post-list.scss';

var getMobileNewsCardStyle = function getMobileNewsCardStyle(index) {
  return index > 1 ? 'is-half-mobile' : 'is-full-mobile';
};

var getMobileNewsCardExcerptStyle = function getMobileNewsCardExcerptStyle(index) {
  return index > 1 ? 'is-hidden-mobile' : '';
};

var getRowClass = function getRowClass(itemsPerRow) {
  return itemsPerRow === 3 ? 'is-one-third-tablet' : 'is-one-quarter-tablet';
};

export var PostList = function PostList(_ref) {
  var posts = _ref.posts,
      itemsPerRow = _ref.itemsPerRow;
  var rowClass = getRowClass(itemsPerRow);
  return /*#__PURE__*/React.createElement("div", {
    className: "post-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "columns is-multiline is-mobile"
  }, posts.map(function (post, i) {
    var _post$title, _post$post_preview$ex, _post$post_preview, _post$post_preview$pr, _post$post_preview2, _post$post_preview2$p, _post$post_preview$pr2, _post$post_preview3, _post$post_preview3$p, _post$slug, _parseISO;

    return /*#__PURE__*/React.createElement("div", {
      className: "column " + rowClass + " " + getMobileNewsCardStyle(i),
      key: i
    }, /*#__PURE__*/React.createElement(Card, {
      title: (_post$title = post === null || post === void 0 ? void 0 : post.title) !== null && _post$title !== void 0 ? _post$title : '',
      excerpt: (_post$post_preview$ex = post === null || post === void 0 ? void 0 : (_post$post_preview = post.post_preview) === null || _post$post_preview === void 0 ? void 0 : _post$post_preview.excerpt) !== null && _post$post_preview$ex !== void 0 ? _post$post_preview$ex : '',
      image: {
        url: (_post$post_preview$pr = post === null || post === void 0 ? void 0 : (_post$post_preview2 = post.post_preview) === null || _post$post_preview2 === void 0 ? void 0 : (_post$post_preview2$p = _post$post_preview2.previewImage) === null || _post$post_preview2$p === void 0 ? void 0 : _post$post_preview2$p.sourceUrl) !== null && _post$post_preview$pr !== void 0 ? _post$post_preview$pr : '',
        alt: (_post$post_preview$pr2 = post === null || post === void 0 ? void 0 : (_post$post_preview3 = post.post_preview) === null || _post$post_preview3 === void 0 ? void 0 : (_post$post_preview3$p = _post$post_preview3.previewImage) === null || _post$post_preview3$p === void 0 ? void 0 : _post$post_preview3$p.altText) !== null && _post$post_preview$pr2 !== void 0 ? _post$post_preview$pr2 : ''
      },
      path: (_post$slug = post === null || post === void 0 ? void 0 : post.slug) !== null && _post$slug !== void 0 ? _post$slug : '',
      date: (_parseISO = parseISO(post === null || post === void 0 ? void 0 : post.date)) !== null && _parseISO !== void 0 ? _parseISO : new Date(),
      excerptClassName: getMobileNewsCardExcerptStyle(i)
    }));
  }))));
};
export default PostList;